const CaptionBlock = ({ caption }) => (
  <span className="block absolute bottom-2 left-2 bg-black bg-opacity-50 text-white p-2 rounded-md max-w-4/5">
    <p className="text-sm">{caption}</p>
  </span>
);

export default CaptionBlock;
